/* unplugin-vue-components disabled */import { render } from "./ApplePage.vue?vue&type=template&id=b9773072&scoped=true"
import script from "./ApplePage.vue?vue&type=script&lang=js"
export * from "./ApplePage.vue?vue&type=script&lang=js"

import "./ApplePage.vue?vue&type=style&index=0&id=b9773072&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9773072"]])

export default __exports__